import React, { useEffect, useState } from "react";
import { SelectWithSearch, SelectOption } from "../../../utils/select-with-search";

// Unit of measure picker for every INC screen that captures a `unit`.
//
// The column itself is still a plain string, so this component hands the parent
// the unit's short name (falling back to its full name) rather than an id — the
// point is only that the value comes from the Material Management unit master
// instead of being typed by hand, so "Mtr", "mtr" and "meter" can never end up
// on three lines of the same BOQ.
interface UnitSelectProps {
  value: string;
  onChange: (unit: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const unitLabel = (u: any) => (u?.short_name || u?.name || "").trim();

const UnitSelect: React.FC<UnitSelectProps> = ({
  value,
  onChange,
  placeholder = "Unit...",
  className = "",
  disabled = false,
}) => {
  const [selected, setSelected] = useState<SelectOption | null>(null);

  // Keeps the box in step when the parent resets the form (add a line, clear
  // the row) or pre-fills the unit from the chosen material item.
  useEffect(() => {
    setSelected((prev) => {
      if (!value) return null;
      if (prev && prev.label === value) return prev;
      return { id: -1, label: value, value };
    });
  }, [value]);

  return (
    <div className={className}>
      <SelectWithSearch
        value={selected}
        onChange={(option) => {
          setSelected(option);
          onChange(option ? String(option.label) : "");
        }}
        apiEndpoint="/inc/material-units"
        dataKey="units"
        labelKey="name"
        displayFormat={unitLabel}
        placeholder={placeholder}
        minSearchLength={0}
        disabled={disabled}
      />
    </div>
  );
};

export default UnitSelect;
